module.exports = __webpack_public_path__ + "img/buscador.b599e930.png";